import { render, staticRenderFns } from "./CompanyShow.vue?vue&type=template&id=1bc65f9c&scoped=true&"
import script from "./CompanyShow.vue?vue&type=script&lang=js&"
export * from "./CompanyShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc65f9c",
  null
  
)

export default component.exports